import { createSelectors, initWishlistStore } from "@jog/react-components"

export const useWishlist = createSelectors(initWishlistStore())
